import {PaymentsCart} from '@guestapp/sdk';

function checkIfTotalAmountToPayZero(paymentsCart?: PaymentsCart) {
  const isTotalAmountNotZero = Boolean(
    parseFloat(paymentsCart?.total_amount_to_pay || '0'),
  );
  const isRetentionAmountNotZero = Boolean(
    parseFloat(paymentsCart?.retention_payments_total || '0'),
  );
  const isPreAuthAmountNotZero = Boolean(
    parseFloat(paymentsCart?.pre_auth_payments_total || '0'),
  );

  return !isTotalAmountNotZero && !isRetentionAmountNotZero && !isPreAuthAmountNotZero;
}

function getTotalPayNow(
  depositFee: number,
  amount?: string,
  outside_paid_amount?: string | null,
) {
  if (!amount && !outside_paid_amount) {
    return 0;
  }
  const totalAmount = parseFloat(amount || '0') + depositFee;
  const amountPaid = parseFloat(outside_paid_amount || '0');
  const isInvalidAmountPaid = Number.isNaN(amountPaid);

  if (isInvalidAmountPaid) {
    return totalAmount;
  }
  return (totalAmount - amountPaid).toFixed(2);
}

export {checkIfTotalAmountToPayZero, getTotalPayNow};
